import axios from 'axios'

const url = process.env.REACT_APP_API_URL || 'http://localhost:5000/v0'

const defaultConfig = {
    baseURL: url,
    withCredentials: true,
    headers: {
        "Content-Type": "application/json",
    },
}

const instance = axios.create({...defaultConfig})

// Add interceptor to include auth token
instance.interceptors.request.use((config) => {
    const auth = localStorage.getItem('auth')
    if (auth) {
        const { token } = JSON.parse(auth)
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
})

export default instance
export {
    axios as defaultAxios,
    instance as axios,
}
